























import VueOptions from '@utils/VueOptions'
import RecessAPI from '@services/RecessAPI'
import Carousel from '@ui/Carousel'

settings =
  name: 'FormFieldUpload'

  vue:
    props: ['value', 'errors', 'uploadPath', 'accept', 'canRemove']

    components: {
      Carousel,
    }

    data: ->
      images: @value
      filesToUpload: []

    computed:
      uploadAction: ->
        "#{RecessAPI.endpoint()}/#{@uploadPath}" if @uploadPath

      acceptFormats: ->
        @accept || 'image/*,image/heic'

      optionsForCarousel: ->
        uploadPath: @uploadAction
        perPage: if document.body.clientWidth < 768 then 2.25 else 3.5

      actionsForCarousel: ->
        onUpload: @onUploadChange
        remove: @onRemoveImage if @canRemove

    mounted: ->
      @$emit 'focus'

    methods:
      hiUploadPreview: ->
        @onUploadPreview()

      inputChanged: (images) ->
        @$emit 'upload', images
        # @$emit 'change', images

      onUploadChange: ->
        # @$emit 'onUpload'
        @inputChanged @images

      onUploadPreview: ->

      onRemoveImage: (url) ->
        @images = @images.filter((image) -> image isnt url)
        @$emit 'input', @images

      addAttachment: (file) ->
        await @uploadFile(@uploadAction, file.file)
        @onUploadChange()

    watch:
      value: (v) ->
        @images = v

export default VueOptions.vue settings
